import { BusinessUnit } from '@delen/connect-core';

export interface IConfigGlobal {
  appName: string;
  teamName: string;
  version: string;

  supportedPreviewMimeTypes: string[];

  // 2-factor code
  codeLength: number;
  codeAllowedChars: string;

  validBusinessUnits: BusinessUnit[];
}

export const globalConfig: IConfigGlobal = {
  appName: 'public-document-sharing',
  teamName: 'digital',
  version: '20260206.1',

  supportedPreviewMimeTypes: ['application/pdf', 'image/jpeg', 'image/png'],

  // 2-factor code
  codeLength: 6,
  codeAllowedChars: '[0-9]',

  validBusinessUnits: [
    BusinessUnit.DelenBelgium,
    BusinessUnit.DelenLuxembourg,
    BusinessUnit.DelenSwitzerland,
    BusinessUnit.DelenNetherlands,
  ],
};
